import * as React from "react";

interface PropsType {
  /**
   * `true` > show password
   * `false` > hide password
   */
  status: boolean;

  /**
   * @default #7D8996
   */
  color?: string;
}

function Eye({ status, color = "#7D8996" }: PropsType) {
  const d = status
    ? "M1 12C2.73 7.61 7 4.5 12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z"
    : "M2 4.27L4.28 6.55L4.73 7C3.08 8.3 1.78 10 1 12C2.73 16.39 7 19.5 12 19.5C13.55 19.5 15.03 19.2 16.38 18.66L16.81 19.08L19.73 22L21 20.73L3.27 3L2 4.27ZM15 12.16L11.83 9H12C13.6569 9 15 10.3431 15 12V12.16ZM9.08 11.35L7.53 9.8C7.2 10.47 7 11.21 7 12C7 14.7614 9.23858 17 12 17C12.79 17 13.53 16.8 14.2 16.47L12.65 14.92C12.44 14.97 12.22 15 12 15C10.3431 15 9 13.6569 9 12C9 11.77 9.03 11.56 9.08 11.35ZM17 12C17 9.23858 14.7614 7 12 7C11.35 7 10.74 7.13 10.17 7.35L8 5.2C9.26 4.75 10.6 4.5 12 4.5C17 4.5 21.27 7.61 23 12C22.27 13.86 21.07 15.5 19.57 16.75L16.64 13.82C16.87 13.26 17 12.64 17 12Z";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d={d} fill={color} />
    </svg>
  );
}

export default Eye;
